import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';

import {
	createTokenAccount
} from '../../../../redux/actions';

import {
	manipulateClipBoardToKeepNumericsOnly
} from '../../../../redux/util';

class CreateTokenAccount extends Component {

	constructor(props) {
        super(props);
        this.state = {
			createTokenAccountForm: {
				params: {
					firstName: '',
					lastName: '',
					email: '',
					userName: '',
					phone: '',
					accountNumber: '',
				},
				errors: {
					firstNameError: '',
					lastNameError: '',
					emailError: '',
					userNameError: '',
					phoneError: '',
					accountNumberError: '',
				}
			},
        }
    }

	updateParams(formName, event) {
		//Reseting Errors on change
		const self = this;
		const name = event.target.name;
		self.setState({
			[formName]: {
				...self.state[formName],
				params: {
					...self.state[formName].params,
					[name]: event.target.value
				}
			}
		}, () => {
			if(self.state[formName].errors[name + 'Error']) {
				self.setState({
					[formName]: {
						...self.state[formName],
						errors: {
							...self.state[formName].errors,
							[name+'Error']: ''
						},
					},
				});
			}
		});
	}

	componentWillMount() {
		const self = this;
		const { userDetails } = self.props.state.user;
		// redirect user to home page if he has not access to this page
		if(userDetails && !userDetails.isSiteManagementAccess) {
			browserHistory.push('/home');
		}
	}

	onBlurValidatePhoneNumber(event) {
		const self = this;
		const phone = event.target.value;
		self.setState({
			createTokenAccountForm: {
				...self.state.createTokenAccountForm,
				errors: {
					...self.state.createTokenAccountForm.errors,
					phoneError: event.target.value !== "" && !self.props.isValidPhoneNumber(event.target.value)?"error":""
				}
			}
		}, () => {
			if(self.props.isValidPhoneNumber(phone)) {
				self.setState({
					createTokenAccountForm: {
						...self.state.createTokenAccountForm,
						params: {
							...self.state.createTokenAccountForm.params,
							phone: self.props.normalizePhoneNumber(phone)
						}
					}
				});
			}
		});
	}

	handleSubmit(event) {
		const self = this;
		const { params, errors } = self.state.createTokenAccountForm;
		let formError = false;
		//Reset all errors
		for(var key in errors) {
            if(!params[key.replace("Error","")]) {
                errors[key] = 'error';
                formError = true;
            } else {
				errors[key] = '';
			}
        }

		// check if valid phone number entered
		if(!self.props.isValidPhoneNumber(params.phone)) {
			formError = true;
			errors.phoneError = "error";
		}

		self.setState({
			params,
			errors,
			serviceCallCompleted: false,
			errorMessage: '',
			confirmationMessage: '',
		}, () => {
			if(!formError) {
				const payload = JSON.parse(JSON.stringify(self.state.createTokenAccountForm.params));
				payload.phone = payload.phone.replace("(", "").replace("-", "").replace(")", "").replace(" ", "");
				self.props.createTokenAccount(payload, response => {
					if(response.status && response.responseObject) {
						self.setState({
							serviceCallCompleted: true,
							confirmationMessage: 'User successfully created in EBS'
						});
					} else {
						self.setState({
							errorMessage: response.responseMessage
						});
					}
				});
			}
		});
	}

    render() {
		const self = this;
		const { createTokenAccountForm: { params, errors } } = self.state;
        return (
            <div>
				<div className="push">
					<h1 className="pageTitle">Create Token Account</h1>
				</div>
				{this.state.errorMessage?<p className="red bold push">{this.state.errorMessage}</p>:null}
				{this.state.confirmationMessage?<p className="bold push">{this.state.confirmationMessage}</p>:null}
				<div className="largePush">
					<table style={{width: '50%'}} className="formTableTypeA createOrderTableA">
						<tbody>
							<tr>
								<td className="first-column">First Name</td>
								<td className="middle-column">
									<input disabled={this.state.serviceCallCompleted} className={errors.firstNameError} type="text" name="firstName" onChange={this.updateParams.bind(this, 'createTokenAccountForm')} />
								</td>
							</tr>
							<tr>
								<td className="first-column">Last Name</td>
								<td className="middle-column">
									<input disabled={this.state.serviceCallCompleted} className={errors.lastNameError} type="text" name="lastName" onChange={this.updateParams.bind(this, 'createTokenAccountForm')} />
								</td>
							</tr>
							<tr>
								<td className="first-column">Email</td>
								<td className="middle-column">
									<input disabled={this.state.serviceCallCompleted} className={errors.emailError} type="text" name="email" onChange={this.updateParams.bind(this, 'createTokenAccountForm')} />
								</td>
							</tr>
							<tr>
								<td className="first-column">User Name</td>
								<td className="middle-column">
									<input disabled={this.state.serviceCallCompleted} className={errors.userNameError} type="text" name="userName" onChange={this.updateParams.bind(this, 'createTokenAccountForm')} />
								</td>
							</tr>
							<tr>
								<td className="first-column">Phone</td>
								<td className="middle-column">
									<input disabled={this.state.serviceCallCompleted} onBlur={this.onBlurValidatePhoneNumber.bind(this)} onKeyPress={this.props.acceptNumbersOnly} className={errors.phoneError} type="text" value={params.phone} name="phone" onChange={this.updateParams.bind(this, 'createTokenAccountForm')} />
								</td>
							</tr>
							<tr>
								<td className="first-column">Account Number</td>
								<td className="middle-column">
									<input
										disabled={this.state.serviceCallCompleted}
										className={errors.accountNumberError}
										type="text"
										name="accountNumber"
										onChange={this.updateParams.bind(this, 'createTokenAccountForm')}
										onKeyPress={this.props.acceptNumbersOnly}
										onPaste={(e) => manipulateClipBoardToKeepNumericsOnly((event) => {
											this.updateParams('createTokenAccountForm', event);
										}, e)}
									/>
								</td>
							</tr>
							{!this.state.serviceCallCompleted && <tr>
								<td />
								<td className="middle-column">
		                            <input type="button" onClick={this.handleSubmit.bind(this)} className="blueButton uppercase" defaultValue="Submit" />
								</td>
							</tr>}
						</tbody>
					</table>
					{this.state.serviceCallCompleted && <div>
						<p><Link to={"/siteManagement/manageAssets"}>Return to Previous Screen</Link></p>
						<div className="clear" />
					</div>}
					<p>
						<Link to="/siteManagement">Back to Site Management</Link>
					</p>
				</div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	createTokenAccount: (payload, callback) => dispatch(createTokenAccount(payload, callback)),
});

CreateTokenAccount = connect(mapStateToProps, mapDispatchToProps)(CreateTokenAccount);
export default CreateTokenAccount;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/SiteManagement/CreateTokenAccount/index.js